var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-container"},[_c('div',{staticClass:"block-head"},[_vm._t("head")],2),_c('div',{staticClass:"block-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }